import { Row } from '@tanstack/react-table';
import { MantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperations';
import { DocumentTable } from '@dealstack/frontend/shared/components/Documents/DocumentTable/DocumentTable';
import { TableContainer } from './styled';
import { GetDocumentsRes } from '@dealstack/shared/lib/generated';
import { DocumentsRes } from '@dealstack/frontend/shared/dataExchange/services/shared/types';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { DocumentViewerModalV2 } from '@dealstack/frontend/shared/components/DocumentViewerV2/DocumentViewerModalV2';

interface Props {
	documentsPayload?: GetDocumentsRes;
	tableDataOperations: MantineTableDataOperations;
	onRowClick: (row: Row<DocumentsRes>) => void;
	showFilters: boolean;
	columns: ExtendedColumnDef<DocumentsRes>[];
	isLoading: boolean;
	previewDocument:
		| {
				downloadUrl: string;
				fileExtension: string;
				fileName: string;
		  }
		| undefined;
	setPreviewDocument: (
		previewDocument:
			| {
					downloadUrl: string;
					fileExtension: string;
					fileName: string;
			  }
			| undefined
	) => void;
}

export const DocumentsTable = ({
	documentsPayload,
	tableDataOperations,
	onRowClick,
	isLoading,
	showFilters,
	columns,
	previewDocument,
	setPreviewDocument,
}: Props) => {
	return (
		<TableContainer>
			<DocumentTable<DocumentsRes>
				dataOperations={tableDataOperations}
				hasNoTopToolbar={!showFilters}
				columns={columns}
				onRowClick={onRowClick}
				isLoading={isLoading}
				data={documentsPayload?.documents}
				enableRowSelection={false}
				enableColumnResizing={true}
				pinnedColumnIds={['name']}
				rowCount={documentsPayload?.meta.rowCount}
			/>

			{previewDocument && (
				<DocumentViewerModalV2
					opened={!!previewDocument}
					onClose={() => setPreviewDocument(undefined)}
					file={previewDocument.downloadUrl}
					fileExtension={previewDocument.fileExtension}
					fileName={previewDocument.fileName}
					isLoading={false}
					showDetailsByDefault={false}
				/>
			)}
		</TableContainer>
	);
};
